import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Paper,
  Divider,
} from '@mui/material';
import { OrderInfo } from '../types/budget';

interface OrderInfoFormProps {
  orderInfo: OrderInfo;
  onChange: (field: keyof OrderInfo, value: any) => void;
}

export const OrderInfoForm: React.FC<OrderInfoFormProps> = ({ orderInfo, onChange }) => {
  const handleInputChange = (field: keyof OrderInfo) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.type === 'number' ? Number(event.target.value) : event.target.value;
    onChange(field, value);
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" gutterBottom>
        Order Information
      </Typography>
      <Divider sx={{ mb: 3 }} />
      
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr 1fr' }, gap: 2 }}>
        {/* Company and Date */}
        <TextField
          fullWidth
          label="Company"
          value={orderInfo.company}
          onChange={handleInputChange('company')}
          variant="outlined"
        />
        <TextField
          fullWidth
          label="Date"
          type="date"
          value={orderInfo.date}
          onChange={handleInputChange('date')}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          fullWidth
          label="Buyer"
          value={orderInfo.buyer}
          onChange={handleInputChange('buyer')}
          variant="outlined"
        />
        <TextField
          fullWidth
          label="Sales Contract"
          value={orderInfo.salesContract}
          onChange={handleInputChange('salesContract')}
          variant="outlined"
        />

        {/* Style and Item */}
        <TextField
          fullWidth
          label="Style"
          value={orderInfo.style}
          onChange={handleInputChange('style')}
          variant="outlined"
        />
        <TextField
          fullWidth
          label="PO"
          value={orderInfo.po}
          onChange={handleInputChange('po')}
          variant="outlined"
        />
        <TextField
          fullWidth
          label="Item Description"
          value={orderInfo.item}
          onChange={handleInputChange('item')}
          variant="outlined"
          sx={{ gridColumn: { xs: '1', md: 'span 2' } }}
        />

        {/* Quantities and Prices */}
        <TextField
          fullWidth
          label="Order Quantity"
          type="number"
          value={orderInfo.orderQty}
          onChange={handleInputChange('orderQty')}
          variant="outlined"
        />
        <TextField
          fullWidth
          label="Export Quantity"
          type="number"
          value={orderInfo.expQty}
          onChange={handleInputChange('expQty')}
          variant="outlined"
        />
        <TextField
          fullWidth
          label="Price per Piece"
          type="number"
          value={orderInfo.pricePerPc}
          onChange={handleInputChange('pricePerPc')}
          variant="outlined"
          inputProps={{ step: '0.01' }}
        />
        <TextField
          fullWidth
          label="Export Value"
          type="number"
          value={orderInfo.exportValue}
          onChange={handleInputChange('exportValue')}
          variant="outlined"
          inputProps={{ step: '0.01' }}
        />
        <TextField
          fullWidth
          label="Order Value"
          type="number"
          value={orderInfo.orderValue}
          onChange={handleInputChange('orderValue')}
          variant="outlined"
          inputProps={{ step: '0.01' }}
        />

        {/* L/C Information */}
        <TextField
          fullWidth
          label="L/C No."
          value={orderInfo.lcNo || ''}
          onChange={handleInputChange('lcNo')}
          variant="outlined"
        />
        <TextField
          fullWidth
          label="L/C Date"
          type="date"
          value={orderInfo.lcDate || ''}
          onChange={handleInputChange('lcDate')}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          fullWidth
          label="L/C Value"
          type="number"
          value={orderInfo.lcValue || ''}
          onChange={handleInputChange('lcValue')}
          variant="outlined"
          inputProps={{ step: '0.01' }}
        />
        <TextField
          fullWidth
          label="Ship Date"
          type="date"
          value={orderInfo.shipDate || ''}
          onChange={handleInputChange('shipDate')}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
        />

        {/* Production Information */}
        <TextField
          fullWidth
          label="SMV"
          type="number"
          value={orderInfo.smv || ''}
          onChange={handleInputChange('smv')}
          variant="outlined"
          inputProps={{ step: '0.01' }}
        />
        <TextField
          fullWidth
          label="No. of Machines"
          type="number"
          value={orderInfo.noOfMc || ''}
          onChange={handleInputChange('noOfMc')}
          variant="outlined"
        />
        <TextField
          fullWidth
          label="Production/Hour"
          type="number"
          value={orderInfo.prodHour || ''}
          onChange={handleInputChange('prodHour')}
          variant="outlined"
          inputProps={{ step: '0.01' }}
        />
        <TextField
          fullWidth
          label="MC Cost"
          type="number"
          value={orderInfo.mcCost || ''}
          onChange={handleInputChange('mcCost')}
          variant="outlined"
          inputProps={{ step: '0.01' }}
        />
      </Box>
    </Paper>
  );
};
